module.exports = __webpack_public_path__ + "media/bootstrap-icons/reply-fill-877a9a60.svg";